export const getErrorMessage = (error) => {
  return error.split("\n")[1].split(":")[1];
};
